import type { ComponentProps } from 'react'

import { ChevronDown } from 'lucide-react'

import { cn } from '@fortem-monorepo/js-utilities'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@fortem-monorepo/react-ui'

export interface SectionProps extends ComponentProps<typeof Collapsible> {
  title: string
}

export const Section: React.FC<SectionProps> = ({ title, className, children, ...props }) => {
  return (
    <div className={cn('border border-indigo-200 rounded-lg bg-white overflow-hidden', className)}>
      <Collapsible className={cn('group')} {...props}>
        <CollapsibleTrigger asChild>
          <div className="px-4 py-2 group-data-[state=open]:border-b group-data-[state=open]:border-indigo-200 bg-indigo-50/70 hover:bg-blue-100/70 cursor-pointer flex items-center gap-2 justify-between">
            <div className={'text-sm text-gray-900'}>{title}</div>
            <ChevronDown className={'text-indigo-400 group-data-[state=open]:scale-[-1]'} />
          </div>
        </CollapsibleTrigger>
        <CollapsibleContent>{children}</CollapsibleContent>
      </Collapsible>
    </div>
  )
}
